import { jsx as _jsx } from "react/jsx-runtime";
import { Snippet as HeroSnippet } from '@heroui/react';
export const Snippet = (props) => {
    return _jsx(HeroSnippet, { ...props });
};
export default Snippet;
//# sourceMappingURL=Snippet.js.map